export function updateBreadcrumb (currentRotute, menuList, isForm, formIsEdit, newText, isExternal, isRecollect) {
  let path = isExternal ? currentRotute.fullPath : currentRotute.path
  let navInfo = currentRotute.meta.navInfo
  let copyMenus = JSON.parse(JSON.stringify(menuList))
  //  既没有设置meta信息也不是菜单树上的action
  if (!navInfo && !getMenuTreeAction(path, copyMenus, isExternal).length) {
    return []
  }
  // 若设置meta信息优先以meta为准
  if (navInfo) {
    let targetData = findParentByMeta(navInfo, copyMenus)[0]
    if (targetData) {
      let targetPathArr = getPathArr(targetData, [])
      let lastPathTitle = navInfo.split('/')[navInfo.split('/').length - 1].replace(/\s+/g, '')
      let subTitle = isRecollect ? '创建重采' : (formIsEdit ? '编辑' : (newText || '新建'))
      lastPathTitle = isForm ? subTitle + lastPathTitle : lastPathTitle
      let currentPath = { title: lastPathTitle, path: path }
      targetPathArr.push(currentPath)
      return targetPathArr
    }
  }
  // 其次判断是不是菜单树上的action
  if (getMenuTreeAction(path, copyMenus, isExternal).length) {
    return getMenuTreeAction(path, copyMenus, isExternal) && getPathArr(getMenuTreeAction(path, copyMenus, isExternal)[0], [])
  }
}
// 判断路由是不是菜单树上的action，如果是并返回
function getMenuTreeAction (currentPath, menuList, isExternal) {
  var filter
  if (isExternal) {
    filter = menuList.filter(item => {
      return filterRoute(currentPath, item, 'url', isExternal)
    })
  } else {
    filter = menuList.filter(item => {
      return filterRoute(currentPath, item, 'url')
    })
  }
  return filter
}
// 根据meta信息获取对应的菜单
function findParentByMeta (navInfo, menuList) {
  let navArr = navInfo.split('/').map(e => e.replace(/\s+/g, ''))
  var filter = menuList.filter(item => {
    return filterRoute(navArr[0], item)
  })
  return filter
}
// 过滤方法
function filterRoute (menuName, routeObj, propName = 'displayName', isExternal) {
  let fullPath = routeObj[propName]
  let questionIndex = fullPath && fullPath.indexOf('?')
  let menuPath = isExternal ? fullPath : (questionIndex > 0 ? fullPath.substring(0, questionIndex) : fullPath)
  let urlIndex = menuName && menuName.indexOf('?url=')
  let externalTypeIndex = menuName && menuName.indexOf('&externalType=')
  let menuNameFinal = (externalTypeIndex > 0 && urlIndex > 0) ? menuName.substring(urlIndex + 5, externalTypeIndex) : (urlIndex > 0 ? menuName.substring(urlIndex + 5, menuName.length) : menuName)
  menuNameFinal = isExternal ? decodeURIComponent(menuNameFinal) : menuNameFinal
  if (routeObj[propName] && menuPath === menuNameFinal) return true
  if (routeObj.hasOwnProperty('children') && routeObj.children) {
    routeObj.children = routeObj.children.filter(child => {
      return filterRoute(menuNameFinal, child, propName, isExternal)
    })
    if (routeObj.children.length > 0) {
      return true
    }
  } else {
    return false
  }
}
/**
 * 把对象转换成数组
 * {displayName :'AA',children:[{displayName :'BB'}]} ====>[{displayName :'AA'},{displayName :'BB'}]
 */
function getPathArr (obj, arr) {
  if (JSON.stringify(obj) !== '{}') {
    var ex = {
      'title': obj.displayName,
      'path': obj.url
    }
    arr.push(ex)
    if (obj.hasOwnProperty('children') && obj.children) {
      getPathArr(obj.children[0], arr)
    } else {
      return arr
    }
  }
  return arr
}
